import callApi from 'common/callApi';
import callPaymentApi from 'common/callPaymentApi';

import { BOOKING_RECEIVED } from 'common/constants';

export const getSetupIntentDetail = (setupParameters: any) =>
  (dispatch: any) =>
    dispatch(
      callPaymentApi(
        `/completegraze` +
        `?pi_guid=${encodeURIComponent(setupParameters.pi_guid)}` +
        `&totalAmount=${encodeURIComponent(setupParameters.totalAmount)}` +
        `&tipAmount=${encodeURIComponent(setupParameters.tipAmount)}` +
        `&acct_id=${encodeURIComponent(setupParameters.acct_id)}` +
        `&setup_intent=${encodeURIComponent(setupParameters.setup_intent)}` +
        `&setup_intent_client_secret=${encodeURIComponent(setupParameters.setup_intent_client_secret)}`
      )
    ).then(result => result.json());

export const getEvents = ({ firstDate, skip = 0, pageSize = 2 }) =>
  dispatch => dispatch(callApi(`v1/Events/calendarEvent?firstDate=${firstDate}&skip=${skip}&pageSize=${pageSize}`))
    .then(result => result.json());

export const getBookings = ({ skip = 0, pageSize = 2, showCompleted = false } = {}) => {
  const filters = [
    { field: 'isConfirmed', value: true, operator: 'eq' },
    { field: 'status', value: 'Complete', operator: showCompleted ? 'eq' : 'neq' },
  ];

  const filtersToQueryString = encodeURIComponent(JSON.stringify(filters));

  return dispatch => dispatch(callApi(`v1/bookings?skip=${skip}&pageSize=${pageSize}&filters=${filtersToQueryString}`))
    .then(result => result.json());
};

export const getBooking = (bookingId: any, previousBooking?: any) =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${bookingId}`))
    .then(result => result.json())
    .then(booking => {
      if (booking && booking.eventDetails?.chitChat?.length > 0) {
        booking.eventDetails.chitChat = booking.eventDetails.chitChat.map(thread => ({
          ...thread,
          showComments: thread.showComments || false,
        }));

        if (booking.eventLinkNumber === previousBooking?.eventLinkNumber && previousBooking.eventDetails?.chitChat) {
          const previousChitChat = previousBooking.eventDetails.chitChat;

          booking.eventDetails.chitChat = booking.eventDetails.chitChat.map(thread => {
            const previousThread = previousChitChat.find(t => t.id === thread.id);

            return {
              ...thread,
              showComments: previousThread ? previousThread.showComments : thread.showComments,
            };
          });
        }

      }
      dispatch(bookingReceived(booking));

      return booking;
    });

export const confirmBooking = (booking: any, confirmedContact: string) =>
  dispatch => dispatch(callApi(
    `v1/bookings/${booking.id}/confirm/${confirmedContact}`,
    { body: null, contentType: null, method: 'POST' }
  ))
    .then(result => {
      if (result.status === 200) {
        const confirmedContactDate = new Date().toISOString();
        const updatedBooking = { ...booking, confirmedContact, confirmedContactDate };

        dispatch(bookingReceived(updatedBooking));
      }
    });
/*
export const getImage = bookingId =>
  dispatch => dispatch(callApi(`v1/files/booking/${bookingId}/customerImage`))
    .then(result => {
      if (result.status !== 204) {
        return result.json();
      } else { return result; }
    });
*/
export const getFinancialDetails = bookingId =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${bookingId}/financialsummary`))
    .then(result => {
      if (result.data) {
        return result.json();
      } else {
        return result;
      }
    });

export const makePayment = (payload: any) =>
  dispatch => dispatch(callApi(`BookingPayment/Authorize`,
    { body: payload, contentType: "application/json", method: 'POST' }))
    .then(result => result.json());

export const getLocation = bookingId =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${bookingId}/location`))
    .then(result => result.json());

export const getEventLocation = (eventGuid, eventId) =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${eventGuid}/location/${eventId}`))
    .then(result => result.json());

export const bookingReceived = booking => ({
  type: BOOKING_RECEIVED,
  booking,
});

export const getPaymentDetailsById = (paymentId: string) =>
  dispatch => dispatch(callApi(`BookingPayment/${paymentId}`,
    { contentType: "application/json", method: 'GET' }))
    .then(result => result.json());

export const makeCoverPaymentCall = (payload: any, id: string) =>
  dispatch => dispatch(callApi(`v1/payments/payment/event/${id}/location`, { body: payload, contentType: "application/json", method: 'POST' }))
    .then(result => result.json());

export const fetchPaymentHistory = (bookingId: string) =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${bookingId}/payment`,
    { contentType: "application/json", method: 'GET' }))
    .then(result => result.json());

export const makePaymentCall = (payload: any, processor: string) =>
  dispatch => dispatch(callPaymentApi(`/event/payments`, { body: payload, contentType: "application/json", method: 'POST', processor: processor }))
    .then(result => result.json());

export const getPaymentLinkDetails = (eventLinkNumber: string) =>
  dispatch => dispatch(callApi(`api/hpay/eventlink/${eventLinkNumber}/paymentdetails`, { contentType: "application/json", method: 'GET' }))
    .then(result => result.json());

export const postCreatePaymentLink = (payload: any, processor: string) => dispatch => dispatch(callPaymentApi(`/payment-link/payment`, { body: payload, contentType: "application/json", method: 'POST', processor: processor })).then(result => result.json());

export const createPandaDoc = (payload: any) =>
  dispatch => dispatch(callApi(`api/hpay/pandadoc/create-document`, { contentType: "application/json", method: 'POST', body: payload }))
    .then(result => result.json());

export const getPandaDocStatusById = (eventLinkNumber: string) =>
  dispatch => dispatch(callApi(`api/hpay/pandadoc/documents/${eventLinkNumber}`, { contentType: "application/json", method: 'GET' }))
    .then(result => result.json());

export const sendPandaDoc = (body: any) =>
  dispatch => dispatch(callApi(`api/hpay/pandadoc/send-document`, { contentType: "application/json", method: 'POST', body: body }))
    .then(result => result.json()).catch(err => {
      console.error(err);
      err.json();
    });

